import { render, staticRenderFns } from "./chexiao.vue?vue&type=template&id=035b2c1a&scoped=true"
import script from "./chexiao.vue?vue&type=script&lang=js"
export * from "./chexiao.vue?vue&type=script&lang=js"
import style0 from "./chexiao.vue?vue&type=style&index=0&id=035b2c1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035b2c1a",
  null
  
)

export default component.exports